<template>
  <div >
    <v-list-item-group v-model="item" color="primary" style="width: 100%" v-if="dados.length > 0">
      <!-- Header -->
      <v-row style="background-color: #2196F3; color: white; width: 100%; margin-left: 0px;">
        <!-- <v-col cols="12" sm="12" md="2">Nome Professor</v-col> -->
        <v-col cols="12" sm="12" md="2">Mini Pauta Da Disciplina</v-col>
        <v-col cols="12" sm="12" md="2">Curso</v-col>
        <v-col cols="12" sm="12" md="2">Turma</v-col>
        <v-col cols="12" sm="12" md="1">Ano </v-col>
        <v-col cols="12" sm="12" md="2">Status</v-col>
      </v-row>

      <!-- Linhas de dados -->
      <v-row v-for="(item, index) in dadosPaginados" :key="index" class="bodyLancamentoNotas">
        <!-- <v-col cols="12" sm="12" class="text-truncate" md="2">{{ item.nome }}</v-col> -->
        <v-col cols="12" sm="12" class="text-truncate" md="2">{{ item.disciplina }}</v-col>
        <v-col cols="12" sm="12" md="2">{{ item.curso }}</v-col>
        <v-col cols="12" sm="12" md="2">{{ item.turma }}</v-col>
        <v-col cols="12" sm="12" md="1">{{ item.anoacademico }}</v-col>
        <v-col cols="12" sm="12" md="2">
          <span v-if="item.isNotaLancada === 1" style="color: green;">Mini Pauta Lançada e Bloqueada</span>
          <span v-else-if="item.isNotaLancada === 0" style="color: blue;">Mini Pauta Em Edição</span>
          <span v-else style="color: red;">Mini Pauta Pendente</span>
        </v-col>
      </v-row>
    </v-list-item-group>

    <!-- Sem resultados -->
    <v-alert v-if="filtersApplied && dados.length === 0" prominent type="warning" class="mt-4 text-center">
      <div class="title text-center">Nenhum resultado encontrado.</div>
    </v-alert>

    <!-- Informações de paginação e controles -->
    <div class="d-flex justify-space-between align-center my-4" v-if="dados.length > 0">
      <div class="text-subtitle-2">
        Página {{ paginaAtual }} de {{ totalPaginas }} - Total de {{ dados.length }} itens
      </div>
      <div>
        <v-select
          v-model="itensPorPagina"
          :items="[10, 20, 30, 40, 50]"
          label="Itens por página"
          dense
          hide-details
          style="max-width: 150px"
        />
      </div>
      <div>
        <v-pagination
          v-model="paginaAtual"
          :length="totalPaginas"
          total-visible="7"
          color="primary"
          prev-icon="mdi-chevron-left"
          next-icon="mdi-chevron-right"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dados: {
      type: Array,
      required: true,
    },
    tipoResultado: {
      type: String,
      required: true,
      validator: value => ['porTurma', 'porAno'].includes(value),
    },
  },
  data() {
    return {
      paginaAtual: 1,
      itensPorPagina: 10,
      filtersApplied: false
    };
  },
  watch: {
    dados() {
      this.paginaAtual = 1;
      this.filtersApplied = true;
    },
    itensPorPagina() {
      this.paginaAtual = 1;
    }
 },
  computed: {
    totalPaginas() {
      return Math.ceil(this.dados.length / this.itensPorPagina) || 1;
    },
    dadosPaginados() {
      const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
      return this.dados.slice(inicio, inicio + this.itensPorPagina);
    },
  },
  watch: {
    dados() {
      this.paginaAtual = 1; // Reinicia quando novos dados chegam
    },
    itensPorPagina() {
      this.paginaAtual = 1; // Reinicia ao mudar qtd de itens por página
    }
  },
  methods: {
  }
};
</script>

<style scoped>
.v-simple-table {
  background-color: transparent !important;
}
.v-simple-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05) !important;
}
.v-chip {
  font-size: 0.75rem;
  height: 24px !important;
  min-width: 100px;
}
.bodyLancamentoNotas{
  color: #080808 !important;
}
</style>